import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const useBuyStore = create()(
  persist(
    (set, get) => ({
      // Independent objects
      objects: {},

      // Set a single object with a key
      setObject: (key, value) =>
        set((state) => ({
          objects: {
            ...state.objects,
            [key]: value,
          },
        })),

      // Get a single object by key
      getObject: (key) => get().objects[key],

      // Add a reset method to restore initial state
      reset: () => set({ objects: {} }),
    }),
    {
      name: "buy-store",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useBuyStore;
